import { styled } from '../../styled';
import { token } from '@zillow/constellation';

export const StyledInputError = styled.div`
  font-size: 12px;
  color: ${token('colors.red400')};
  padding-top: 8px;
`;
